// copied from VPC

import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { ConnectedMetricValuePillWrapper } from '../ConnectedMetricValuePill';
import { ConnectedMetricUpdatedCell } from './MetricUpdatedCellFormatter';

export function MetricValueCell(): React.Factory<BodyCell.Props> {
  return React.createFactory(function PlainTextCell(props: BodyCell.Props) {
    return <ConnectedMetricValuePillWrapper row={props.row} />;
  });
}

export function MetricUpdatedCell(): React.Factory<BodyCell.Props> {
  return React.createFactory(function DateTimeCell(props: BodyCell.Props) {
    return <ConnectedMetricUpdatedCell {...props} />;
  });
}
